export default {
  originCity: 'Kies de plaats van vertrek',
  destinationCity: 'Kies aankomst stad',
  direct: 'Direct',
  indirect: '1+ tussenstops',
  getPrices: 'Prijzen ophalen',
  directAvailable: 'Direct beschikbaar vanaf',
}
